import { Injectable } from '@angular/core';
import { BalanceSheetCollectionQuery, BalanceSheetCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(BalanceSheetCollectionQuery)
@Wrapper(BalanceSheetCollectionQueryHandlerBase)
export class BalanceSheetCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
